import { useAppReworkMigration } from "@/lib/hooks/use-app-rework-migration";

/**
 * Til een oude, lokale appversie-keuze één keer naar de server.
 *
 * Een component en geen aanroep in `App`, om dezelfde reden als de andere luisteraars hier: `App`
 * hangt boven elke router, en een hook die daar een netwerkaanroep aanstuurt laat de hele boom
 * hertekenen op iets wat één keer hoeft te gebeuren.
 */
export function AppReworkMigration() {
  useAppReworkMigration();

  return null;
}
